import { Component, inject, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { faqPageJsonLd, organizationJsonLd, softwareApplicationJsonLd } from '../../../shared/data/structured-data';
import { HeroSectionComponent } from "../hero-section/hero-section.component";
import { DemoVideoSectionComponent } from "../demo-video-section/demo-video-section.component";
import { HowItWorksSectionComponent } from "../how-it-works-section/how-it-works-section.component";
import { SocialProofSectionComponent } from "../social-proof-section/social-proof-section.component";
import { FinalCtaSectionComponent } from "../final-cta-section/final-cta-section.component";
import { FaqSectionComponent, HOME_FAQS } from "../faq-section/faq-section.component";
import { IntegrationsSectionComponent } from "../integrations-section/integrations-section.component";
import { TrustSecuritySectionComponent } from "../trust-security-section/trust-security-section.component";
import { CommunitiesPreviewSectionComponent } from "../communities-preview-section/communities-preview-section.component";
import { MobileAppSectionComponent } from "../mobile-app-section/mobile-app-section.component";
import { OperatorBridgeSectionComponent } from "../operator-bridge-section/operator-bridge-section.component";
import { CASE_STUDIES_PUBLISHED } from "../../case-studies/case-studies.data";

@Component({
    selector: 'app-home-page',
    standalone: true,
    imports: [
        HeroSectionComponent,
        OperatorBridgeSectionComponent,
        TrustSecuritySectionComponent,
        DemoVideoSectionComponent,
        CommunitiesPreviewSectionComponent,
        HowItWorksSectionComponent,
        SocialProofSectionComponent,
        FinalCtaSectionComponent,
        FaqSectionComponent,
        IntegrationsSectionComponent,
        MobileAppSectionComponent
    ],
    templateUrl: './home-page.component.html',
    styleUrl: './home-page.component.scss'
})
export class HomePageComponent implements OnDestroy {
    /** Proof section links to case studies; hidden until they are published. */
    readonly showCaseStudies = CASE_STUDIES_PUBLISHED;
    private readonly document = inject(DOCUMENT);
    private readonly scriptIds = ['mt-jsonld-organization', 'mt-jsonld-software', 'mt-jsonld-faq'];

    constructor() {
        const payloads = [organizationJsonLd(), softwareApplicationJsonLd(), faqPageJsonLd(HOME_FAQS)];
        this.scriptIds.forEach((id, index) => this.upsertJsonLd(id, payloads[index]));
    }

    ngOnDestroy(): void {
        this.scriptIds.forEach((id) => this.document.getElementById(id)?.remove());
    }

    private upsertJsonLd(id: string, payload: Record<string, unknown>): void {
        let script = this.document.getElementById(id) as HTMLScriptElement | null;
        if (!script) {
            script = this.document.createElement('script');
            script.id = id;
            script.type = 'application/ld+json';
            this.document.head.appendChild(script);
        }
        script.textContent = JSON.stringify(payload);
    }
}
